module.exports = {
  siteTitle: 'Parin Patel | SRE',
  siteDescription:
    'Parin Patel, Site Reliability Engineer @ SpaceX',
  siteKeywords:
    'Parin Patel, Parin, Patel, parinapatel, DevOps engineer, DevOps, Software Engineer, Linux, Python, Kubernetes, Docker, CI/CD, continuous Development, Monitoring, Alluxio, MongoDB, Nginx, Proxy, Docker, AWS, midwest,Chicago',
  siteUrl: 'https://parinapatel.github.io',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-97218061-2',
  googleVerification: 'WlgD3BYn52bBWqrjAa1ucfEiP0voHyf2VsumefyytXI',
  name: 'Parin Patel',
  location: 'Seattle, WA',
  email: 'parinpatel921996@gmail.com',
  github: 'https://github.com/parinapatel',
  twitterHandle: '',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/parinapatel'
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/parin-patel/'
    },
    {
      name: 'Youtube',
      url: 'https://www.youtube.com/channel/UCL_fx-DKk1_obP74BJ93wLA'
    }
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about'
    },
    {
      name: 'Experience',
      url: '/#jobs'
    },
    {
      name: 'Projects',
      url: '/#projects'
    },
    {
      name: 'Blog',
      url: '/pensieve/'
    },
    {
      name: 'Contact',
      url: '/#contact'
    }
  ],

  navHeight: 100,
  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: {x: 0, y: 0, z: 0},
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: {top: 0, right: 0, bottom: 0, left: 0}
  })
};
